import { FC } from 'react';
import EmptyIcon from 'components/Icons/EmptyIcon';

interface EmptyHorizontalProps {
  description: string;
}

const EmptyHorizontal: FC<EmptyHorizontalProps> = ({ description }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
      <EmptyIcon style={{ fontSize: 48 }} />
      {description}
    </div>
  );
};

export default EmptyHorizontal;
